import { usePortfolioData } from "../../i18n";
import React from "react";
import PortfolioCard from "../common/portfolioCard";

import styles from "./styles/allProjects.module.css";

/**
 * 홈페이지에서 쓰이는 컴포넌트
 */
const ProjectSummary = () => {
  const { projects: PROJECTS } = usePortfolioData();
  // 홈페이지(/)일 경우 showOnHome이 true인 프로젝트만 필터링
  const visibleProjects = PROJECTS.filter((project) => project.showOnHome);
  return (
    <div className={styles["all-projects-container"]}>
      {visibleProjects.map((project) => (
        <div className={styles["all-projects-project"]} key={project.id}>
          <PortfolioCard item={project} variant="compact" />
        </div>
      ))}
    </div>
  );
};

export default ProjectSummary;
